<template lang="pug">
	.project-settings-actions-delete(v-if="showed")
		.card
			.card-header
				i.fa.fa-edit
				span Delete Project
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label Are you sure you want to delete this project?
					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="deleteProject()") Delete project
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template';
	import { Settings } 		from './../../services/Settings';

	export default {
		name: "ProjectActionsDelete",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false
		},
		data() {

			this.Template = Template;
			this.Settings = Settings;

			return {

			};

		},
		methods: {
			deleteProject() {

				Server.sendToSocket({
					DeleteProject: Project.SelectedProject.id
				});

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.project-settings-actions-delete
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 180px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark
				float: right
				color: #fff

</style>

